import { action, runInAction } from "mobx";
import * as LoginAPI from '../../../api/pc/login';
import { LOCATION_ORIGN } from "../../../constants";

export class MEbBindStore {

  skinInfo: any = {};//皮肤数据信息
  //初始数据
  @action
  init = () => {
    this.getDomainSkinData();
  }

  //获取自定义皮肤数据
  getDomainSkinData = () => {
    const origin = LOCATION_ORIGN;
    LoginAPI.getCustomDomainSkin(origin, 'h5').then((result: any) => {
      runInAction(() => {
        if (result.data?.tenantKey) {
          this.skinInfo.tenantKey = result.data?.tenantKey;
        }
      });
    }).catch((error) => {

    });
  }

}

const instance = new MEbBindStore();

export default instance;
export type MEbBindStoreType = Pick<MEbBindStore, keyof MEbBindStore>;
